import { render, staticRenderFns } from "./KisTaskEditDialog.vue?vue&type=template&id=0dd6081f"
import script from "./KisTaskEditDialog.js?vue&type=script&lang=js&external"
export * from "./KisTaskEditDialog.js?vue&type=script&lang=js&external"
import style0 from "./KisTaskEditDialog.vue?vue&type=style&index=0&id=0dd6081f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports